import { useQueryClient } from '@tanstack/react-query';
import { useUtilityJWETokenQuery } from '@syf-api-library/utility-jwe';
import { getApiConfig, useCoreConfigProvider } from '@account-services-mfe/core';
import { useDebtCancellationGetQuery } from '../services/get/use-debt-cancellation-get-query';
import { useDebtCancellationPutQuery } from '../services/put/use-debt-cancellation-put-query';
const useDebtCancellationGet = (accountId) => {
    const queryClient = useQueryClient();
    const mfeConfig = useCoreConfigProvider();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useDebtCancellationGetQuery({
        keyProps: { accountId, accountIdType: 'guid' },
        ...apiConfig
    });
};
const useDebtCancellationPut = (accountId) => {
    const queryClient = useQueryClient();
    const mfeConfig = useCoreConfigProvider();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useDebtCancellationPutQuery({
        keyProps: undefined,
        ...apiConfig
    });
};
const useUtilityJWETokenGet = (accountId, shouldFetchToken) => {
    const queryClient = useQueryClient();
    const mfeConfig = useCoreConfigProvider();
    const shouldEnabled = Boolean(accountId) && shouldFetchToken;
    const apiConfig = getApiConfig(queryClient, mfeConfig, shouldEnabled);
    return useUtilityJWETokenQuery({
        keyProps: { accountId, accountIdType: 'guid' },
        ...apiConfig
    });
};
export { useDebtCancellationGet, useDebtCancellationPut, useUtilityJWETokenGet };
